import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        setToken(data.token);
        setUser(data);
        window.history.replaceState(null, "", "/profiles");
        navigate("/profiles", { replace: true });
      } catch (err) {
        if (err.response?.status === 403) toast.error("No Bubz + account found for this Google email.");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FFFDF7]">
      <div className="text-center animate-floaty">
        <div className="text-5xl font-display font-bold text-[#FF5A79]">Bubz</div>
        <p className="mt-3 text-slate-500">Signing you in…</p>
      </div>
    </div>
  );
}
